import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';
import { forkJoin, of } from 'rxjs';
import { ToastComponent } from 'src/app/core-files/loaders/toast-messages';
import { SharedService } from 'src/app/core-files/shared.service.';
import { SharedServices } from 'src/app/services/shared.service';
import { SidebarService } from 'src/app/services/sidebar.service';
import { domain } from 'src/app/variables/domain';
import { AddAgentPropertiesService } from 'src/app/services/add-agent-properties.service';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-upload-property-images',
  templateUrl: './upload-property-images.component.html',
  styleUrls: ['./upload-property-images.component.scss'],
  standalone: false
})
export class UploadPropertyImagesComponent implements OnInit {
  @Input() PropertyId: any;
  @ViewChild('filepicker') uploader!: ElementRef;
  // @Input() type: any;
  isUserLoggedIn: any;
  selectedImages: FileList;
  imageUrls: any = [];
  uploadedImages: any = [];
  id: any;
  canDismiss = false;
  imageUrl = domain.imageUrlProperty;
  isDataLoaded: boolean = false;
  constructor(
    // public alertController: AlertController,
    public alertController: AlertController,
    private loadingController: LoadingController,
    private modal: ModalController,
    private addAgentPropertiesService: AddAgentPropertiesService,
    private sidebarService: SidebarService,
    private sharedservice: SharedService,
    private toastComponent: ToastComponent,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.getImages(this.PropertyId);
    });
    this.sharedservice.getPropertyImageDeleted.subscribe((res) => {
      if (res) {
        this.getImages(this.PropertyId);
        this.sharedservice.setPropertyImageDeleted(false);
      }
    });
  }

  openUploadImagesModal(item) {
    // this.modal.create({
    //   component: UploadPropertyImagesComponent,
    //   componentProps: {
    //     propertyId: item.PropertyId
    //   }
    // }).then(modal => modal.present());
  }

  async getImages(propertyId: any) {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please Wait...",
    });
    await loading.present();

    this.sidebarService.getImages(propertyId).subscribe({
      next: async (res) => {
        await loading.dismiss();
        this.isDataLoaded = true;
        this.uploadedImages = res;
        // this.imageUrls = res;
      },
      error: async (err) => {
        await loading.dismiss();
        this.isDataLoaded = true;
      }
    });
  }

  addFile() {
    this.uploader.nativeElement.click();
  }
  async deleteImage(imageId) {
    const loadingCtrl = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Deleting...",
    });
    await loadingCtrl.present();
    // await this.sharedservice.deleteData(
    //   'property-image',
    //   imageId,
    //   "Delete Property Image",
    //   "Are you sure you want to delete this property image?"
    // );
    this.addAgentPropertiesService.DeletePropertyImage(imageId).subscribe({
      next: async (res) => {

        // this.shareService.setPropertyImageDeleted(true);
        await loadingCtrl.dismiss();
        this.getImages(this.PropertyId);
        this.toastComponent.showToast("Property image Deleted Successfully", "success");
      },
      error: async (err) => {
        // this.shareService.setPropertyImageDeleted(true);
        await loadingCtrl.dismiss();
        this.getImages(this.PropertyId);
        this.toastComponent.showToast("Property image Deleted Successfully", "success");
      }
    });
  }
  fileSelected($event: any) {
    this.selectedImages = $event.target.files;
    let size = 0;
    if (this.selectedImages.length > 0) {
      for (let i = 0; i < this.selectedImages.length; i++) {
        const fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.imageUrls.push(e.target.result);
        };
        fileReader.readAsDataURL(this.selectedImages[i]);
      }
      for (var count = 0; count < this.selectedImages.length; count++) {
        size += this.selectedImages[count].size
      }
    }
    // if (this.selectedImages.length > 3) {
    //   this.setOpen(true);
    // } else if ((size / 1024) > 5120) {
    //   this.toastMessage = "Maximum file size limit is 5MB"
    //   this.setOpen(true);
    // }
  }

  dismissdialog() {
    this.canDismiss = true;

    this.imageUrls = [];
    this.selectedImages = null;
    this.uploader.nativeElement.value = '';
    setTimeout(() => {
      this.modal.dismiss();
    },);

  }
  removeImage(index: number) {
    this.imageUrls.splice(index, 1);
  }
  async uploadImages() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please Wait...",
    });
    await loading.present();

    const requests = [];
    for (let i = 0; i < this.selectedImages.length; i++) {
      const formData = new FormData();
      formData.append("postedFiles", this.selectedImages[i]);
      // setTimeout(() => {
      //    this.newProjectServices.SaveProjectImage(this.Id, formData).subscribe(
      //   async (res) => {
      //     await loading.dismiss();
      //   })
      // });

      requests.push(
        this.addAgentPropertiesService.saveImage(formData, this.PropertyId).pipe(
          catchError(error => of({ error, file: this.selectedImages[i].name }))
        )
      );
    }


    setTimeout(() => {
      forkJoin(requests).subscribe(
        async (results) => {
          await loading.dismiss();
          this.imageUrls = [];
          this.selectedImages = null;
          this.canDismiss = true;
          this.modal.dismiss();
          // this.getImages(this.Id);

          // Check for errors
          // if (failed.length > 0) {
          //   this.toastMessage = `${failed.length} image(s) failed to upload.`;
          // } else {
          //   this.toastMessage = "Images uploaded successfully.";
          //   this.toastComponent.showToast(this.toastMessage, 'success');
          // }
          // this.setOpen(false);
          setTimeout(() => {
            this.modal.dismiss();
          }, 500);
        }
      ), async err => {
        await loading.dismiss();
      };
    }, 1000);
  }
}